// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#app {\r\n  font-family: Avenir, Helvetica, Arial, sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  color: #2c3e50;\r\n  height: 100%;\r\n  width: 100%;\r\n  max-width: 10rem;\r\n  margin: 0 auto;\r\n  /* H5页面选IOS系统滑动卡动问题！ */\r\n  -webkit-overflow-scrolling: touch;\n}\r\n", ""]);
// Exports
module.exports = exports;
